import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import styled from 'styled-components';
import { TableCell, TableRow, IconButton, makeStyles, createStyles } from '@material-ui/core';
import Icon from '../Icon';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    row: {
      backgroundColor: theme.palette.action.hover
    }
  });
});
var StyledTableCell = styled(TableCell).withConfig({
  displayName: "GroupRow__StyledTableCell",
  componentId: "rknxij-0"
})(["font-weight:bold;cursor:", ";padding:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return !disabled ? 'pointer' : 'default';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && '10px 0 10px 40px !important';
});
export var GroupRow = function GroupRow(_ref3) {
  var e2e = _ref3.e2e,
      colSpan = _ref3.colSpan,
      expanded = _ref3.expanded,
      disabled = _ref3.disabled,
      hidden = _ref3.hidden,
      onToggleHeaderRow = _ref3.onToggleHeaderRow,
      children = _ref3.children;
  var classes = useStyles();
  if (hidden) return null;
  return /*#__PURE__*/React.createElement(TableRow, _extends({}, e2e && {
    'data-e2e': e2e
  }, {
    className: classes.row,
    hover: !disabled
  }), /*#__PURE__*/React.createElement(StyledTableCell, {
    colSpan: colSpan,
    padding: "checkbox",
    disabled: disabled,
    onClick: function onClick() {
      return !disabled && onToggleHeaderRow();
    }
  }, !disabled && /*#__PURE__*/React.createElement(IconButton, _extends({}, e2e && {
    'data-e2e': "".concat(e2e, "-button")
  }, {
    color: "primary",
    size: "small",
    style: {
      width: 40,
      height: 40
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    body: expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
  })), children));
};

try {
  GroupRow.__docgenInfo = {
    description: '',
    displayName: 'GroupRow',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      colSpan: {
        defaultValue: null,
        description: '',
        name: 'colSpan',
        required: true,
        type: {
          name: 'number'
        }
      },
      expanded: {
        defaultValue: null,
        description: '',
        name: 'expanded',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      disabled: {
        defaultValue: null,
        description: '',
        name: 'disabled',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      hidden: {
        defaultValue: null,
        description: '',
        name: 'hidden',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      onToggleHeaderRow: {
        defaultValue: null,
        description: '',
        name: 'onToggleHeaderRow',
        required: true,
        type: {
          name: '() => void'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=GroupRow.js.map